import { render, staticRenderFns } from "./afterSalesDialog.vue?vue&type=template&id=3d887c17&scoped=true"
import script from "./afterSalesDialog.vue?vue&type=script&lang=js"
export * from "./afterSalesDialog.vue?vue&type=script&lang=js"
import style0 from "./afterSalesDialog.vue?vue&type=style&index=0&id=3d887c17&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d887c17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d887c17')) {
      api.createRecord('3d887c17', component.options)
    } else {
      api.reload('3d887c17', component.options)
    }
    module.hot.accept("./afterSalesDialog.vue?vue&type=template&id=3d887c17&scoped=true", function () {
      api.rerender('3d887c17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AfterSales/afterSalesDialog.vue"
export default component.exports